export const sectionBlockStyles = {
	header: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	title: {
		fontWeight: 700,
		fontSize: '1.25rem',
		lineHeight: '160%',
		letterSpacing: '0.15px',
		mb: 1
	},
	section: {
		display: 'flex',
		flexDirection: 'column',
		gap: 2
	}
};
